import { useEffect } from "react";
import { useFiiDii } from "../../hooks/useFiiDii";

const FiiDii = () => {
  const {
    fiiDiiByDate,
    latestFiiDii,
    fiiDiiLoading,
    fiiDiiError,
    fetchFiiDiiData,
  } = useFiiDii();

  useEffect(() => {
    fetchFiiDiiData(30);
  }, [fetchFiiDiiData]);

  if (fiiDiiLoading) {
    return <p>Loading FII/DII data...</p>;
  }

  if (fiiDiiError) {
    return <p>{fiiDiiError}</p>;
  }
  const formatValue = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) return "-";

    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getNetColor = (value) => {
    const number = Number(value);

    if (number > 0) return "#16a34a";
    if (number < 0) return "#dc2626";

    return "#6b7280";
  };

  return (
    <div className="stock-table-container">
      <table className="stock-table oc-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>FII Buy</th>
            <th>FII Sell</th>
            <th>FII Net</th>
            <th>DII Buy</th>
            <th>DII Sell</th>
            <th>DII Net</th>
          </tr>
        </thead>

        <tbody>
          {fiiDiiByDate.map((item) => (
            <tr key={item.trade_date}>
              <td>{item.trade_date}</td>

              <td>{item?.fii?.buy_value ?? "-"}</td>
              <td>{item?.fii?.sell_value ?? "-"}</td>
              {/* <td>{item?.fii?.net_value ?? "-"}</td> */}
              <td
                style={{
                  color: getNetColor(item?.fii?.net_value),
                  fontWeight: 700,
                }}
              >
                {formatValue(item?.fii?.net_value)}
              </td>
              <td>{item?.dii?.buy_value ?? "-"}</td>
              <td>{item?.dii?.sell_value ?? "-"}</td>
              {/* <td>{item?.dii?.net_value ?? "-"}</td> */}
              <td
                style={{
                  color: getNetColor(item?.dii?.net_value),
                  fontWeight: 700,
                }}
              >
                {formatValue(item?.dii?.net_value)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FiiDii;
